import { Prescription } from '../store/types/prescription';
import { GET_TRIAL_ORDER_PRESCRIPTION } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
export interface Response {
    status: string;
    prescription: Prescription;
    pid: string;
}

export default (docid: string): Promise<Response> =>
    fetchWithRefresh(GET_TRIAL_ORDER_PRESCRIPTION(docid)).then((res) => res.json());
